import Cookies from "js-cookie";
import { cookie } from "./localizedData"

const Consent = (): void => {
    const cookiebar = document.getElementById('kapsea-cookie-bar');

    const setCookie = (val: boolean, reload: boolean) => {
        Cookies.set(
            cookie.handle,
            val ? "true" : "false",
            {
                expires: cookie.expiry,
                secure: cookie.secure,
            }
        );
        if (reload) {
            location.reload();
        } else {
            if (cookiebar) cookiebar.style.display = 'none';
        }
    }
    document.getElementById('cookie-bar-accept')?.addEventListener('click', () => setCookie(true, true));
    document.getElementById('cookie-bar-refuse')?.addEventListener('click', () => setCookie(false, false));
    document.getElementById('kapsea-reject-cookies')?.addEventListener('click', () => setCookie(false, true));
}

export { Consent };